export enum InviteStatus {
  pending = 1,
  declined,
  expired,
}
